import { Controller } from '@hotwired/stimulus'
import { HTMLElementEvent } from '../types'

export class NestedFormController extends Controller {
  static targets = ['list', 'template']

  declare readonly listTarget: HTMLElement
  declare readonly templateTarget: HTMLElement

  toggle() {
    const card = this.element.querySelector('.empty-state-card')
    if (card) {
      const btn = this.element.querySelector('.btn-nested-results')

      if (this.element.querySelectorAll('.nested-record').length > 0) {
        card.classList.add('d-none')
        btn.classList.remove('d-none')
      } else {
        card.classList.remove('d-none')
        btn.classList.add('d-none')
      }
    }
  }

  add(event: HTMLElementEvent<HTMLElement>) {
    event.preventDefault()

    const timestamp = new Date().getTime().toString()
    const content = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      timestamp,
    )
    this.listTarget.insertAdjacentHTML('afterbegin', content)
    this.toggle()
  }

  remove(event: HTMLElementEvent<HTMLElement>) {
    event.preventDefault()
    let wrapper: HTMLInputElement =
      event.target.closest('.nested-form-item') ||
      event.target.closest('.nested-record')

    // New records are simply removed from the page
    if (wrapper.dataset.newRecord == 'true') {
      wrapper.remove()
      // Existing records are hidden and flagged for deletion
    } else {
      wrapper
        .querySelector("input[name*='_destroy']")
        .setAttribute('value', '1')
      wrapper.classList.add('hide')
      wrapper.style.display = 'none'
    }
    this.toggle()

    this.element.closest('form').dispatchEvent(new Event('nested-form:remove'))
  }
}
